<template>
  <div>
    <el-dialog
      title=""
      center
      :visible.sync="visible"
      width="460px"
      :before-close="handleClose"
      append-to-body
    >
      <template slot="title">
        <div>批量验收入库</div>
      </template>
      <el-form :model="form" ref="formRef" label-width="150px" size="mini">
        <el-form-item label="商品数量:"> {{ list.length }} </el-form-item>
        <el-form-item label="验收数量:"> {{ getNumTotal() }} </el-form-item>
        <el-form-item
          label="仓库:"
          prop="stash_id"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <el-select
            style="width: 200px"
            v-model="form.stash_id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stashArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center; color: #f59a23">
        提示:批量验收默认验收入库数量等于需采购数量
      </div>
      <template slot="footer">
        <el-button
          type="primary"
          :loading="btnLoading"
          :disabled="btnLoading"
          @click="confirm"
          >确定</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { countNum ,preciseSubtract} from "@/util/utils";
export default {
  props: ["stashArr"],
  data() {
    return {
      visible: false,
      form: {
        stash_id: "",
        num: "",
      },
      list: null,
      btnLoading: false,
    };
  },
  methods: {
    getDetails(list) {
      this.list = list;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    getNumTotal() {
      let num0 = countNum(this.list, "purchase_num");
      let num1 = countNum(this.list, "accept_num");
      return  preciseSubtract(num0*1 ,num1*1)
    },
    toggle(show) {
      this.visible = show;
      // this.$refs.formRef.clearValidate();
      !show && this.reset();
    },
    reset(done) {
      this.form.stash_id = "";
      this.list = [];
      done && done();
    },
    handleClose() {
      this.toggle(false);
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let listId = this.list.map((item) => item.order_ids);
          let listId2 = listId.flat();
          let _params = {
            ids: listId2.join(","),
            // num: this.getNumTotal(),
            stash_id: this.form.stash_id,
            type: 2,
          };
          this.btnLoading = true;
          this.$http
            .post("/admin/accept/operation", _params)
            .then((res) => {
              if (res.code == 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>